import React, { useEffect, useState } from "react";

const Time = () => {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const formatTime = (date) => {
        // Get time components
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();
        
        // Determine AM/PM
        const ampm = hours >= 12 ? 'PM' : 'AM';
        
        // Convert to 12-hour format
        hours = hours % 12;
        hours = hours ? hours : 12; // 0 should be 12
        
        // Pad with zeros
        const paddedHours = hours.toString().padStart(2, '0');
        const paddedMinutes = minutes.toString().padStart(2, '0');
        const paddedSeconds = seconds.toString().padStart(2, '0');
        
        // Get timezone (AEST/AEDT automatically)
        const timezone = date.toLocaleTimeString('en-AU', { 
            timeZoneName: 'short' 
        }).split(' ')[2];
        
        return `${paddedHours}:${paddedMinutes}:${paddedSeconds}${ampm} (${timezone})`;
    };

    return (
        <div className="c-splash__time">
            {formatTime(time)}
        </div>
    );
};

export default Time;